import {} from "@/api/schema";
import { bytesToString } from "@/utils/utils";
export const DEFAULT_QUOTA_SOURCE_LABEL = "Default";
/**
 * Converts a raw UserQuotaUsageData response to a QuotaUsage object.
 * @param data The raw UserQuotaUsageData response.
 * @returns The QuotaUsage object.
 */
export function toQuotaUsage(data) {
    return new QuotaUsageModel(data);
}
class QuotaUsageModel {
    constructor(data) {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._data = data;
    }
    get rawSourceLabel() {
        var _a;
        return (_a = this._data.quota_source_label) !== null && _a !== void 0 ? _a : null;
    }
    get sourceLabel() {
        var _a;
        return (_a = this.rawSourceLabel) !== null && _a !== void 0 ? _a : DEFAULT_QUOTA_SOURCE_LABEL;
    }
    get quotaInBytes() {
        return this._data.quota_bytes;
    }
    get totalDiskUsageInBytes() {
        return this._data.total_disk_usage;
    }
    get quotaPercent() {
        return this._data.quota_percent;
    }
    get niceQuota() {
        if (this.isUnlimited) {
            return "unlimited";
        }
        if (this.quotaInBytes !== undefined && this.quotaInBytes !== null) {
            return bytesToString(this.quotaInBytes, true, undefined);
        }
        return "unknown";
    }
    get niceTotalDiskUsage() {
        return bytesToString(this.totalDiskUsageInBytes, true, undefined);
    }
    get isUnlimited() {
        return !this.quotaInBytes;
    }
}
